export default function Formats() {
  const formats = [
    { icon: 'ri-building-2-line', title: 'Очный тренинг', desc: 'Интенсивная работа в аудитории с полным погружением. Практика на реальных переговорах, ролевые игры, разбор записей.' },
    { icon: 'ri-computer-line', title: 'Онлайн', desc: 'Живые сессии через видеосвязь с отработкой диалогов. Полное сохранение практической направленности.' },
    { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Несколько модулей с интервалами для внедрения навыков в работу. Домашние задания между встречами.' },
    { icon: 'ri-user-follow-line', title: 'С сопровождением', desc: 'Полный цикл: диагностика, тренинг, посттренинговый аудит и поддержка в Telegram.' },
    { icon: 'ri-building-line', title: 'Корпоративная академия', desc: 'Системное построение обучения продажам внутри компании: стандарты, регламенты, Книга продаж.' },
  ];

  return (
    <section id="formats" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Выберите формат, который подходит вашей компании. Программа адаптируется под любой из них.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {formats.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-xl text-teal-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}